<template>
  <div class="renewletter-container flex-grow-1" v-show="isRenewalExist">
    <div class="renewletter_content d-flex">
      <div
        class="icon-wrapper flex-shrink-0 d-flex align-items-center justify-content-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
        >
          <g fill="none">
            <path
              d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"
            />
            <path
              fill="currentColor"
              d="m13.299 3.148l8.634 14.954a1.5 1.5 0 0 1-1.299 2.25H3.366a1.5 1.5 0 0 1-1.299-2.25l8.634-14.954c.577-1 2.02-1 2.598 0M12 15a1 1 0 1 0 0 2a1 1 0 0 0 0-2m0-7a1 1 0 0 0-.993.883L11 9v4a1 1 0 0 0 1.993.117L13 13V9a1 1 0 0 0-1-1"
            />
          </g>
        </svg>
      </div>
      <div
        class="content-wrap d-flex  flex-grow-1 justify-content-between"
      >
        <p class="content-text">
          New Rate for L713, and NAWU as of January 1st, 2026
        </p>
        <button class="pay_now m-0" v-b-modal.renew_modal @click="displayRenewalModal()">
          View Renew Letter
        </button>
      </div>
    </div>

    <b-modal id="renew_modal" size="lg" centered hide-footer hide-header>
      <img
        @click="closeRenewalModal()"
        class="close_cross"
        src="@/assets/images/cross.svg"
        alt="cross"
      />
      <div class="renew_modal_container">
        <div
          class="img_wrapper d-flex align-items-center justify-content-center"
        >
          <img :src="logoimg" alt="renew letter" class="mb-4" />
        </div>
        <div class="subject_content mb-4">
          <strong>Subject:</strong> Reminder: Access Your Group's 2026 Renewal
          Rates Online
        </div>
        <div class="mb-4 d-flex flex-column letter_head_info gap-1">
          <div class="group_name">{{ groupInfo.group_name }}</div>
          <div class="group_address">
            {{ groupInfo.gaddress1 }}, {{ groupInfo.gcity }}, {{ groupInfo.gstate }} {{ groupInfo.gzip }}
          </div>
          <strong class="date_wrap">12/1/2025</strong>
        </div>
        <div class="main_content">
          <div class="main_head mb-2">
            Dear <strong>{{ groupInfo.group_contact_first_name }} {{ groupInfo.group_contact_last_name }}</strong>,
          </div>
          <p class="mb-3">
            This is a friendly reminder as of January 1st, 2026, the medical
            plans will be renewed for your employee(s). There is nothing you
            need to do on your end as the renewal is automatic. This is just a
            formal notification of the rate change for January 2026 - December
            2026.
          </p>
          <p class="mb-3">
            Billing will be adjusted accordingly on your upcoming statement or
            electronic payment (EFT).
          </p>
          <p class="mb-3">
            Your new rate for your benefit plan as of January 1st, 2026 will be
            as follows:
          </p>
          <div class="table-responsive mb-3">
            <table>
              <thead>
                <tr>
                  <td>Employee Name</td>
                  <td>Plans</td>
                  <td>Tier</td>
                  <td>New Rate</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(member, index) in memberList" :key="index">
                  <td>{{ member.first_name }} {{ member.last_name }}</td>
                  <td>{{ member.plan_name }}</td>
                  <td>{{ member.tier }}</td>
                  <td>${{ member.new_rate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="mb-3">
            This new rate will be effective until the next renewal on December
            31st, 2026.
          </p>
          <p class="mb-3">
            If you have any questions, you may contact your representative or
            broker.
          </p>
          <div class="d-flex flex-column mb-3">
            <p class="font-semibold">Sincerely,</p>
            <p>NuEra Billing Services</p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import logoimg from "@/assets/images/darknuera.png";
import Api from "@/resource/Api";

export default {
  name: "RenewLetter",
  props: {
    isRenewalExist: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      logoimg,
      memberList: [],
      groupInfo: {},
    };
  },
  mounted() {
    if (this.isRenewalExist) {
      this.displayRenewalModal();
    }
  },
  watch: {
    isRenewalExist(val) {
      if (val) {
        this.displayRenewalModal();
      } else {
        this.closeRenewalModal();
      }
    }
  },
  methods: {
    displayRenewalModal() {
      // let loader = this.$loading.show();
      // this.$bvModal.show('renew_modal');
      Api.get("get-group-member-new-rate-details")
        .then((res) => {
          this.memberList = res.data.data.members;
          this.groupInfo = res.data.data.group_info;
        })
        .catch(err => console.error("API Error:", err))
        .finally(() => {
          // loader.hide();
        });
    },
    closeRenewalModal() {
      this.memberList = [];
      this.groupInfo = {};
      this.$bvModal.hide('renew_modal');
    }
  },
};
</script>

<style src="@/assets/css/group_dashboard/renewletter.css"></style>
